import Axios from "../../../../../api/axios/Axios";

export const fetchProfile = () => Axios.get("/api/u/account");
export const updateProfile = (profile) => Axios.put("/api/u/account", profile);
export const updatePassword = (password) =>
  Axios.put("/api/u/password", { password });
export const deleteAccount = () => Axios.delete("/api/u/account");
